import { type FeatureFlag, featureFlags } from "@/config/featureFlags";

/**
 * Returns whether a feature flag is enabled.
 *
 * Reads from the runtime config (which is populated from FEATURE_* env vars
 * on the frontend server). Falls back to false if runtime config isn't loaded.
 */
export function useFeatureFlag(flag: FeatureFlag): boolean {
  return featureFlags[flag];
}
